<template>
  <div class="flex items-center w-2/3 space-x-4">
    <div class="flex flex-col">
      <h2 class="text-32px font-bold text-left mb-5">{{ $t('video_interview.micro-test') }}</h2>
      <p class="text-neutral-50 text-base text-left mb-5">
        {{ $t('video_interview.indicator-reacts') }}
      </p>
      <p class="text-neutral-600 text-left">
        {{ $t('video_interview.if-indicator-donot-reacts') }}
      </p>
    </div>
    <img src="@/assets/icons/micro.svg" alt="">
    <audio :src="checks[0]"></audio>
  </div>
</template>
<script>
export default {
  name: 'CheckMicro',
  data() {
    return {
      checks: [],
    };
  },
  mounted() {
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then((stream) => {
        const mediaRecorder = new MediaRecorder(stream);
        mediaRecorder.start();
        setTimeout(() => {
          mediaRecorder.stop();
          this.$emit('micro-checked');
        }, 8000);

        mediaRecorder.addEventListener('dataavailable', (event) => {
          this.checks.push(event.data);
        });
      });
  },
};
</script>
<style lang="scss">

</style>
